import React, { useCallback } from 'react'
import { Checkbox, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { useUpdateDishesStatusFlagsMutation } from '../../hooks'

const DishTableStatusCheckbox = ({
  dishId,
  statusFlagFieldName,
  value,
  isDisabled,
  tooltip,
}) => {
  const [updateStatusFlag] =
    useUpdateDishesStatusFlagsMutation(statusFlagFieldName)

  const handleChange = useCallback(
    event => updateStatusFlag([dishId], event.target.checked),
    [dishId, updateStatusFlag],
  )

  return (
    <Tooltip title={tooltip}>
      <Checkbox checked={value} onChange={handleChange} disabled={isDisabled} />
    </Tooltip>
  )
}

DishTableStatusCheckbox.propTypes = {
  dishId: PropTypes.string.isRequired,
  statusFlagFieldName: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  tooltip: PropTypes.string,
}

DishTableStatusCheckbox.defaultProps = {
  isDisabled: false,
  tooltip: undefined,
}

export default DishTableStatusCheckbox
